import { combineReducers } from 'redux'
import eventsReducer from './events/reducers'
import tasksReducer from './tasks/reducers'

export default combineReducers({
	events: eventsReducer,
	tasks: tasksReducer,
})
